import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const schema = Yup.object({
  name: Yup.string().required("Name is required"),
  slug: Yup.string().required("Slug is required"),
  notes: Yup.string().nullable(),
});

export default function OrganisationForm({
  initialValues,
  onSubmit,
  onCancel,
  submitLabel = "Save",
}) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      slug: "",
      notes: "",
      ...initialValues,
    },
    validationSchema: schema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Name
        </label>
        <input
          id="name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          className="w-full border rounded px-3 py-2 mt-1"
        />
        {formik.touched.name && formik.errors.name && (
          <div className="text-red-500 text-sm">{formik.errors.name}</div>
        )}
      </div>
      <div>
        <label htmlFor="slug" className="block text-sm font-medium text-gray-700">
          Slug
        </label>
        <input
          id="slug"
          name="slug"
          value={formik.values.slug}
          onChange={formik.handleChange}
          className="w-full border rounded px-3 py-2 mt-1"
        />
        {formik.touched.slug && formik.errors.slug && (
          <div className="text-red-500 text-sm">{formik.errors.slug}</div>
        )}
      </div>
      <div>
        <label htmlFor="notes" className="block text-sm font-medium text-gray-700">
          Notes
        </label>
        <textarea
          id="notes"
          name="notes"
          rows={3}
          value={formik.values.notes}
          onChange={formik.handleChange}
          className="w-full border rounded px-3 py-2 mt-1"
        />
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 rounded">
          Cancel
        </button>
        <button
          type="submit"
          disabled={formik.isSubmitting}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          {formik.isSubmitting ? "Saving…" : submitLabel}
        </button>
      </div>
    </form>
  );
}
